<template>
    <transition :name="$route.meta.transition || 'fade'">
        <div class="relative">
            <Loading :loading="loading">
                <component :is="component"></component>
            </Loading>
        </div>
    </transition>
</template>

<script>
import api from '../api';

import NotFound from './NotFound.vue';
import Contentpage from './Contentpage.vue';

export default {
    data: () => ({
        component: null,
        loading: true,
        slug: null
    }),

    mounted() {
        this.init();
    },

    methods: {
        init() {
            this.slug = this.$route.fullPath;

            api.get(`/api/v1/slugs${this.slug}`)
                .then((response) => {
                    let store = response.data.meta.resource_class_name.toLowerCase();
                    this.$store.commit(`${store}/set`, response.data);

                    this.component = response.data.meta.resource_class_name;

                    if (response.data.data.meta_title) {
                        document.title = this.$translate(response.data.data.meta_title) + ' | ' + 'HKCM';
                    }

                    if (response.data.data.meta_description) {
                        document.meta = this.$translate(response.data.data.meta_description) + ' | ' + 'HKCM';
                    }

                    this.loading = false;
                })
                .catch((error) => {
                    this.component = 'NotFound';

                    document.meta = this.$t('This Site could not be found');
                    document.title = this.$t('404 - Not Found');

                    this.loading = false;
                });
        }
    },

    watch: {
        '$route.fullPath': function () {
            // check if next route is the fallback
            if (this.$route.matched.find((route) => route.name === 'fallback')) {
                this.slug = this.$route.fullPath;
                this.init();
            }
        }
    },

    components: {
        NotFound,
        Contentpage
    }
};
</script>
